import {Translate} from "../Translate";

const routesConfig = [
    {
        id: 'dashboard',
        title: Translate.dashboard,
        type: 'item',
        icon: 'dashboard',
        url: '/dashboard',
    },
    {
        id: 'management',
        title: Translate.manageOrders,
        type: 'group',
        permission: 'manageShops',
        children: [
            {
                id: 'makeOrder',
                title: Translate.makeOrder,
                type: 'item',
                icon: 'add_shopping_cart',
                url: '/orders/make',
                exact:true
            },
            {
                id: 'not_payed',
                title: Translate.not_payed,
                type: 'item',
                icon: 'pending',
                url: '/manage/orders/not_payed',
                exact:true
            },
            {
                id: 'get_order',
                title: Translate.get_order,
                type: 'item',
                icon: 'border_color',
                url: '/manage/orders/get_order',
                exact:true
            },
            {
                id: 'set_order',
                title: Translate.set_order,
                type: 'item',
                icon: 'shopping_basket',
                url: '/manage/orders/set_order',
                exact:true
            },
            {
                id: 'delivery_to_customer',
                title: Translate.delivery_to_customer,
                type: 'item',
                icon: 'person',
                url: '/manage/orders/delivery_to_customer',
                exact:true
            },
        ],
    },

    {
        id: 'settings',
        title: Translate.settings,
        type: 'group',
        roles:['admin'],
        children: [
            {
                id: 'manageProducts',
                title: Translate.manageProducts,
                type: 'item',
                icon: 'shopping_cart',
                url: '/manage/manage-products',
                exact:true
            },
            {
                id: 'manageCategories',
                title: Translate.manageCategories,
                type: 'item',
                icon: 'category',
                url: '/manage/manage-categories',
                exact: true
            },
            {
                id: 'allUsers',
                title: Translate.allUsers,
                type: 'item',
                icon: 'group',
                url: '/manage/users/view/all',
                exact:true
            },
            {
                id: 'siteSettings',
                title: Translate.siteSettings,
                type: 'item',
                icon: 'settings_applications',
                url: '/manage/settings',
                exact:true
            },
        ]
    },
    {
        id: 'account',
        title: Translate.account,
        type: 'group',
        children: [
            {
                id: 'settings',
                title: Translate.myAccount,
                type: 'item',
                icon: 'settings',
                url: '/account/details',
            },
            {
                id: 'password',
                title: Translate.changePassword,
                icon: 'password',
                type: 'item',
                url: '/account/password',
            },
        ],
    },
    {
        id: 'fileManager',
        title: Translate.fileManager,
        type: 'item',
        icon: 'image',
        url: '/file-manager',
        permission: "fileManagerPage",
    },
];
export default routesConfig;
